import axios from 'axios';

function resolveBaseURL() {
  const configuredBaseURL = process.env.REACT_APP_API_URL;

  if (!configuredBaseURL || typeof window === 'undefined') {
    return configuredBaseURL || '/api';
  }

  const isLocalBrowser = ['localhost', '127.0.0.1'].includes(window.location.hostname);
  if (!isLocalBrowser) {
    return configuredBaseURL;
  }

  try {
    const url = new URL(configuredBaseURL);
    if (!url.hostname.endsWith('.app.github.dev')) {
      return configuredBaseURL;
    }

    const forwardedPort = url.hostname.match(/-(\d+)\./)?.[1] || url.port || '5001';
    return `http://127.0.0.1:${forwardedPort}${url.pathname}`;
  } catch {
    return configuredBaseURL;
  }
}

const api = axios.create({
  baseURL: resolveBaseURL(),
});

// Attach token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Redirect to login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
